import React, { FC } from 'react';
import { Container, isWidthUp, withWidth } from '@material-ui/core';
import Swiper from 'react-id-swiper';
import cx from 'classnames';

import { QuoteItem } from '../QuoteItem';
import useStyles from './styles';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import { QuotesListBlock } from '../../types';
import { LazyLoadImage } from '../LazyloadImage';

interface QuotesBlockProps {
  data: QuotesListBlock;
  width: Breakpoint;
}

const QuotesBlock: FC<QuotesBlockProps> = ({ data, width }) => {
  const background = data?.background;
  const backgroundImage = data?.background_image;
  const items = data?.quotes || [];
  const isSingleQuoteBlock = items?.length === 1;

  const isMobile = !isWidthUp('md', width);
  const classes = useStyles(background, isSingleQuoteBlock)();

  const swiperSettings = {
    slidesPerView: 1,
    navigation: {
      nextEl: isMobile ? '.swiper-button-next.swiper-button-next-quote' : '.swiper-button-next',
      prevEl: isMobile ? '.swiper-button-prev.swiper-button-prev-quote' : '.swiper-button-prev',
    },
    direction: 'horizontal',
    rebuildOnUpdate: true,
  };

  return (
    <div
      className={cx(
        classes.wrapper,
        'quotes-block',
        !backgroundImage && (background === 'Dark' ? 'dark-block' : 'light-block'),
      )}
    >
      {backgroundImage && (
        <div className={cx(classes.imageWrapper, 'quotes-block__image-wrapper')}>
          <LazyLoadImage
            className={cx(classes.image, 'quotes-block__image')}
            path={backgroundImage}
            alt={'quotes'}
            sizes="100vw"
            draggable={false}
          />
        </div>
      )}
      <Container className={cx(isSingleQuoteBlock && classes.singleContainer)}>
        {isSingleQuoteBlock ? (
          <QuoteItem
            title={items[0]?.title}
            subtitle={items[0]?.sub_title}
            highLightColor={items[0]?.color_text}
            buttonLink={items[0]?.cta_button_link}
            buttonText={items[0]?.cta_button_text}
          />
        ) : (
          <Swiper {...swiperSettings}>
            {items.map((item) => (
              <div key={item?.title}>
                <QuoteItem
                  title={item?.title}
                  subtitle={item?.sub_title}
                  isSingleItem={false}
                  highLightColor={item?.color_text}
                  buttonLink={item?.cta_button_link}
                  buttonText={item?.cta_button_text}
                />
              </div>
            ))}
          </Swiper>
        )}
      </Container>
    </div>
  );
};

export default withWidth()(QuotesBlock);
